// extracted by mini-css-extract-plugin
export default {"actions":"jQg45u5svE"};